import React, {useState} from 'react';

import {HStack, Icon, Text, VStack} from '@chakra-ui/react';
import {OctagonAlert} from "lucide-react";

import {Button} from '@/components';
import {useApi} from "@/uses/useApi";
import {useLanguage} from "@/contexts/languageContext";

export const EntityDeletionConfirmation = ({close, entity, body, item, successCallback}) => {

    const api = useApi();
    const { t } = useLanguage();

    const [error, setError] = useState(null);

    /** Un refus de l'API (ex. type de guide encore utilisé) doit être expliqué */
    const deleteEntity = () => {
        setError(null);
        api.ApiService.delete(entity, item.id)
            .then(_ => {
                successCallback(item);
            })
            .catch((e) => {
                const code = e?.response?.data?.value;
                setError(t(`errors.${code}`, {defaultValue: t('errors.deletionFailed')}));
            });
    }

    return <VStack p="5" w="100%">
        <VStack>
            <VStack align="center">
                <Icon as={OctagonAlert} boxSize={10} color="secondary.500" mx="auto"/>
                <Text fontSize="2xl">{t('misc.deletion')}</Text>
            </VStack>
            {body}
            {error && <Text color="red.500" textAlign="center" px="2rem">{error}</Text>}
        </VStack>
        <HStack align="center" w="100%" gap="2rem" justify="center">
            <Button onClick={() => close()}>{t('actions.cancel')}</Button>
            <Button onClick={deleteEntity}>{t('actions.delete')}</Button>
        </HStack>
    </VStack>;
};

export default EntityDeletionConfirmation;
